'use client'; // Error components must be Client Components
import React from 'react';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { H2, P } from '@/components/ui/typography';
import useHoneybadger from '@/lib/frontend/hooks/useHoneybadger';

/**
 * error.[js|tsx]: https://nextjs.org/docs/app/building-your-application/routing/error-handling
 */
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const { notify } = useHoneybadger();
  useEffect(() => {
    notify(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center gap-10 max-w-lg m-auto my-20">
      <div className="text-center flex flex-col gap-5">
        <H2>We're sorry!</H2>
        <div className="text-center flex flex-col gap-1">
          <P>Something went wrong with the site. We've been notified of the issue.</P>
          <P>You can try refreshing the page or clicking the button below.</P>
        </div>
      </div>
      <Button
        variant="outline"
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </Button>
    </div>
  );
}
